import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibDirectiveModule } from '@mynexus/mynexus-ui-lib';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { FormErrorsModule } from '../form-errors/form-errors.module';
import { DocumentSelectUploadComponent } from './document-select-upload/document-select-upload.component';
import { PacimUloadFilesDialog } from './pacim-upload-files-dialog/pacim-upload-files-dialog.component';
import { SelectedDocumentComponent } from './selected-document/selected-document.component';
import { UploadDocumentsPACIMComponent } from './upload-documents-pacim/upload-documents-pacim.component';
import { UploadFilesPACIMComponent } from './upload-files-pacim/upload-files-pacim.component';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [
    UploadDocumentsPACIMComponent,
    UploadFilesPACIMComponent,
    SelectedDocumentComponent,
    DocumentSelectUploadComponent,
    PacimUloadFilesDialog,
  ],
  exports: [
    UploadDocumentsPACIMComponent,
    UploadFilesPACIMComponent,
    SelectedDocumentComponent,
    DocumentSelectUploadComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    ConfirmDialogModule,
    DialogModule,
    InputTextModule,
    MultiSelectModule,
    DatePickerModule,
    TableModule,
    TooltipModule,
    FormErrorsModule,
    LibDirectiveModule,
    RadioButtonModule,
    MessageModule,
  ],
})
export class DocumentsUploadPACIMModule {}
